import { apiRequest } from 'platform/utilities/api';
import { assertApiEnabled } from 'platform/utilities/feature-toggles/assertApiEnabled';
import { HEALTH_ENROLLMENT_STATUS_ACTIONS } from '../reducers/healthEnrollmentStatus';

const { STARTED, SUCCEEDED, FAILED, RESET } = HEALTH_ENROLLMENT_STATUS_ACTIONS;

export const HEALTH_ENROLLMENT_STATUS_ENDPOINT =
  '/health_care_applications/enrollment_status';

export const fetchHealthEnrollmentStatus =
  ({
    endpoint = HEALTH_ENROLLMENT_STATUS_ENDPOINT,
    formData = {},
    apiFlag,
  } = {}) =>
  async (dispatch, getState) => {
    const { loading } = getState().healthEnrollmentStatus;
    if (loading) return null;

    dispatch({ type: STARTED });

    const { fullName, dob, ssn } = formData;
    const hasIdentityData = [fullName?.first, fullName?.last, dob, ssn].some(
      v => v,
    );
    const userAttributes = hasIdentityData
      ? {
          veteranFullName: { first: fullName?.first, last: fullName?.last },
          veteranDateOfBirth: dob,
          veteranSocialSecurityNumber: ssn,
        }
      : {};

    try {
      assertApiEnabled(getState, apiFlag);
      const response = await apiRequest(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ userAttributes }),
      });
      dispatch({ type: SUCCEEDED, response });
      return response;
    } catch ({ errors }) {
      dispatch({ type: FAILED, errors });
      return null;
    }
  };

export const resetHealthEnrollmentStatus = () => ({ type: RESET });
